import React from 'react'

import { Container } from '../../components/Bootstrap'
import Panel from '../../components/Panel'

import { colours } from '../../theme'

const NextSteps = () => (
	<Panel colour={colours.primary} style={{ marginTop: 0 }}>
		<Container>
			<h2>Next Steps</h2>
			<p>Once the strategic plan is approved by the Board, the following next steps are being recommended:</p>
			<ul>
				<li>
					Develop yearly operational plan from the 2025 Strategic Plan with clear activities,  deliverables and outcomes for Years 1 and 2
					<ul>
						<li>Year 1 (2018-19) plan will include strategy plan renewal, hiring of new ED</li>
						<li>
							Year 2  (2019-20) and beyond will developed by new ED in consultation with staff to include:
							<ul>
								<li>activities to be completed for each year</li>
								<li>a Gantt Chart with clear timelines</li>
								<li>key team members to lead the activities</li>
								<li>monthly progress reviews and identify activities on/off track</li>
								<li>quarterly reports to the Board</li>
								<li>end of year plan and updates for CILT's annual report</li>
							</ul>
						</li>
					</ul>
				</li>
			</ul>
		</Container>
	</Panel>
)

export default NextSteps
